import constate from 'constate';
import { useEffect, useState } from 'react';

const useInitialize = () => {
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsInitialized(true);
    }, 3500);

    return () => clearTimeout(timer);
  }, [setIsInitialized]);

  return {
    isInitialized,
    setIsInitialized
  };
};

export const [InitializeProvider, useInitializeContext] = constate(useInitialize);
